import * as api from '@gitbook/api-client';
import { getSiteProductDefinition } from '@gitbook/app-pricing';
import { Alert } from '@gitbook/spine-react';
import { assertNever } from '@gitbook/util-ts';

import { getTrialEndingNotice } from '../../../Components';
import { useNavigationState } from '../../../navigation';
import { useTrial } from '../../../state';

export function SiteTrialBanner(props: { site: api.Site; organization: api.Organization }) {
    const { site, organization } = props;
    const definition = getSiteProductDefinition(site.type);
    if (definition.key === api.SiteType.Premium || definition.key === api.SiteType.Ultimate) {
        return <PaidPlanCard organization={organization} />;
    }
    return null;
}

function PaidPlanCard(props: { organization: api.Organization }) {
    const { organization } = props;
    const trial = useTrial({ organization });
    const { screen } = useNavigationState();
    const { status } = trial;

    if (status === api.BillingTrialStatus.Active || status === api.BillingTrialStatus.Expired) {
        return (
            <Alert
                size="small"
                kind="upgrade"
                title={getTrialEndingNotice({ daysLeft: trial.daysLeft, prefix: 'GitBook' })}
                details={(() => {
                    switch (status) {
                        case api.BillingTrialStatus.Active:
                            return (
                                <>
                                    During this trial, you'll have access to all features available
                                    on the <strong>Ultimate plan</strong>. Upgrade at any time to
                                    continue accessing paid features.
                                </>
                            );
                        case api.BillingTrialStatus.Expired:
                            return <>Upgrade now to keep your site live.</>;
                        default:
                            assertNever(status, `Unexpected trial status: ${status}`);
                    }
                })()}
                action={
                    organization.permissions.admin
                        ? {
                              label: 'Upgrade',
                              kind: 'upgrade',
                              href: {
                                  overlay: {
                                      type: 'org_settings',
                                      organization: organization.id,
                                      tab: {
                                          type: 'billing',
                                          returnScreen: screen,
                                      },
                                      hash: 'sidebar_cta',
                                  },
                              },
                          }
                        : undefined
                }
            />
        );
    }

    return null;
}
